import React, { useState } from 'react';
import { RouterProvider } from './context/RouterContext';
import Header from './components/Header';
import ResponsiveLayout from './components/ResponsiveLayout';
import UploadModal from './components/UploadModal';

function App() {
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);

  const handleUploadClick = () => {
    setIsUploadModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsUploadModalOpen(false);
  };

  return (
    <RouterProvider>
      <ResponsiveLayout>
        <Header onUploadClick={handleUploadClick} />
      </ResponsiveLayout>
      
      <UploadModal 
        isOpen={isUploadModalOpen} 
        onClose={handleCloseModal} 
      />
    </RouterProvider>
  );
}

export default App;
